export const dietaryPreferences = [
  { label: 'Local', value: 1 },
  { label: 'Traditional', value: 2 },
  { label: 'Vegetarian', value: 3 },
  { label: 'Kosher', value: 4 },
  { label: 'Halal', value: 5 },
]

export const addFoodItemModalInvalidFields = ['name', 'ingredient', 'category', 'amount', 'price']
